module.exports = __webpack_public_path__ + "img/comming-soon.d14c6d4c.png";